package com.appcreator.blueprint.firebase.auth

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("FirebaseAuthSignInWithGoogle")
@ActionClass(
    group = FirebaseAuthConsts.group,
    title = "Sign in with Google",
    isExtraPlugin = true,
    availableFrom = "0.0.1"
)
class FirebaseAuthSignInWithGoogle(
    @InputProperty(
        title = "Configure App Check",
        availableFrom = "0.0.1"
    )
    val configureAppCheck: Boolean?

): Action
